import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Context } from '../../../context/global-data-provider';
import Status from '../../components/status/status';

function E404() {
  const { setCurrentRoute, options } = useContext(Context);

  useEffect(() => {
    setCurrentRoute('/e404');
    document.title = options.title + ' • ' + 'صفحه مورد نظر یافت نشد!';
  }, []);

  return (
    <Status code={404}>
      <div className="f-grow-1 wh-100 align-items-center justify-content-center">
        <h1 className="f-row d-flex">صفحه مورد نظر یافت نشد!</h1>
        <Link to={'/'}>
          <button type="button" className="btn br-c-p bc-b-c mt-12p">
            صفحه اصلی
          </button>
        </Link>
      </div>
    </Status>
  );
}

export default E404;
